import React from "react";
import "./LeaderboardRules.css";
import { Link } from "react-router-dom";

const LeaderboardRules = () => {
  return (
    <div className="rules-wrapper">
      <header className="rules-header">
        <h1>Leaderboard Rules & Conditions</h1>
      </header>
      <section className="penalty-section">
        <h2>Negative Marking Policy</h2>
        <p>
          To ensure fairness and compliance, the following rules were enforced,
          and penalties were applied accordingly. These deductions impacted the
          final points and ranks.
        </p>
        <ul className="policy-list">
          <li>
            <strong>Unauthorized Use of Scripts:</strong> Points were deducted
            for any instances where unapproved or custom scripts were used.
          </li>
          <li>
            <strong>Bot Usage:</strong> Users who automated actions using bots
            or other automated tools faced significant point deductions.
          </li>
          <li>
            <strong>Exceeding Daily Lab Limits:</strong> Penalties were applied
            to users who exceeded their allocated daily usage quota for lab
            resources.
          </li>
          <li>
            <strong>Exceeding Daily Module Limits:</strong> Users who attempted
            to complete more modules than allowed in a single day faced
            additional point deductions.
          </li>
          <li>
            <strong>Access Outside Permitted Hours:</strong> Any unauthorized
            access outside the designated time slots resulted in point
            deductions.
          </li>
        </ul>
      </section>
      <section className="calculation-section">
        <h2>Rank Calculation</h2>
        <p>
          Final ranks were determined based on the total points earned, after
          accounting for any deductions due to rule violations. Compliance with
          the rules led to higher ranks, while violations negatively impacted
          the standings.
        </p>
        <p>
          <strong>Note:</strong> Ranks are now finalized and cannot be changed.
        </p>
        <p>
          <strong>Transparency:</strong> Ranks were calculated anonymously to
          ensure a fair result.
        </p>
      </section>
      <div className="button-wrapper">
        <Link to="/genai-result">
          <button className="leaderboard-btn">Go Back</button>
        </Link>

        <Link to="/leaderboard">
          <button className="leaderboard-btn">View Leaderboard</button>
        </Link>
      </div>
    </div>
  );
};

export default LeaderboardRules;
